import { Component, Input, OnInit } from '@angular/core';
import { DataTableAdapter } from '../../../adapters/datatable.adapter';

@Component({
    selector: 'sn-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.css']
})
export class DataTableComponent implements OnInit {
    @Input() adapter:DataTableAdapter;
    @Input() data_table_view:string;

    constructor() { }

    ngOnInit() {
    }

    isLoading():boolean {
        return this.adapter && this.adapter.showLoadingMessage();
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/data-table/data-table.component.ts